import { z } from "zod";

export default {
  createCheckoutSession: z.object({
    plan: z.enum(["free", "pro"]),
  }),
};
